export enum CheckoutMethods {
    payPerView = 'pay as you go',
    prepaidCredits = 'prepaid',
    subscription = 'subscription',
}
